export default __webpack_public_path__ + "static/media/tpv.f7c9c99a.png";